import adapter from './adapter'
import { collectionGetters } from '@/store/collection'
import { Branch } from './model'

const { getAll, getCollection, itemGetter } = collectionGetters(adapter, {
  constructor: data => new Branch(data)
})


export default {
  getAll,
  getCollection,
  getBranch: itemGetter,
}
